import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Chapters from "@/components/site/Chapters";
import Services from "@/components/site/Services";
import TestCatalog from "@/components/site/TestCatalog";
import Packages from "@/components/site/Packages";
import CorporateWellness from "@/components/site/CorporateWellness";
import PrescriptionUpload from "@/components/site/PrescriptionUpload";
import B2B from "@/components/site/B2B";
import Faq from "@/components/site/Faq";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import BookingModal from "@/components/site/BookingModal";
import ChatWidget from "@/components/site/ChatWidget";
import CartDrawer from "@/components/site/CartDrawer";

export default function Home() {
  const [bookingOpen, setBookingOpen] = useState(false);
  const [bookingItems, setBookingItems] = useState([]);
  const [selected, setSelected] = useState([]);
  const [catalogQuery, setCatalogQuery] = useState("");
  const [cartOpen, setCartOpen] = useState(false);

  const openBooking = (items) => {
    setBookingItems(items || []);
    setBookingOpen(true);
    if (items?.length) setSelected(items);
  };

  const handleSearch = (q) => {
    setCatalogQuery(q);
    const el = document.querySelector("#tests");
    if (el) window.__lenis ? window.__lenis.scrollTo(el, { offset: -70 }) : el.scrollIntoView({ behavior: "smooth" });
  };

  const addToCart = (ids) => {
    setSelected((prev) => [...new Set([...prev, ...ids])]);
    setCartOpen(true);
  };

  return (
    <div data-testid="home-page">
      <Navbar onBook={openBooking} />
      <Hero onBook={openBooking} onSearch={handleSearch} />
      <Marquee />
      <Chapters />
      <Services onBook={openBooking} />
      <PrescriptionUpload onAdd={addToCart} />
      <TestCatalog selected={selected} setSelected={setSelected} onOpenCart={() => setCartOpen(true)} initialQuery={catalogQuery} />
      <Packages onBook={openBooking} />
      <CorporateWellness />
      <B2B />
      <Faq />
      <Contact onBook={openBooking} />
      <Footer onBook={openBooking} />
      <BookingModal open={bookingOpen} initialItems={bookingItems} onClose={() => setBookingOpen(false)} />
      <CartDrawer open={cartOpen} items={selected} onClose={() => setCartOpen(false)}
        onRemove={(id) => setSelected((p) => p.filter((x) => x !== id))}
        onClear={() => setSelected([])}
        onProceed={() => { setCartOpen(false); openBooking(selected); }} />
      <ChatWidget />
    </div>
  );
}
